/* Otwieranie mega menu na desktopie.

   Dawn otwiera panel dopiero na klik. Przy nawigacji sklepowej to o jeden ruch
   za dużo, a jednocześnie sam hover bez opóźnienia rozwija panel każdemu, kto
   tylko przejeżdża myszą przez nagłówek. Stąd trzy zachowania:

   1. najechanie otwiera panel po 140 ms — przypadkowy przejazd go nie ruszy,
   2. klik w pozycję prowadzi do kategorii, bo panel już jest otwarty z hovera
      (na dotyku zostaje natywne rozwijanie — tam nie ma czego najeżdżać),
   3. tabulator otwiera panel na focusie, żeby dało się do niego wejść z klawiatury.

   Zamknięcie ma dłuższe opóźnienie niż otwarcie, żeby zjazd myszą po skosie
   z pozycji do kafla w panelu nie zamykał menu w połowie drogi. */

(function () {
  const OPOZNIENIE_OTWARCIA = 140;
  const OPOZNIENIE_ZAMKNIECIA = 220;

  const naMyszy = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  document.querySelectorAll('header-menu > details.pp-mega').forEach((details) => {
    const summary = details.querySelector('summary');
    const kontener = details.parentElement;
    let timerOtwarcia;
    let timerZamkniecia;

    const otworz = () => {
      if (details.open) return;
      details.open = true;
      summary.setAttribute('aria-expanded', 'true');
    };

    const zamknij = () => {
      if (!details.open) return;
      details.open = false;
      summary.setAttribute('aria-expanded', 'false');
    };

    kontener.addEventListener('mouseenter', () => {
      if (!naMyszy()) return;
      clearTimeout(timerZamkniecia);
      timerOtwarcia = setTimeout(otworz, OPOZNIENIE_OTWARCIA);
    });

    kontener.addEventListener('mouseleave', () => {
      if (!naMyszy()) return;
      clearTimeout(timerOtwarcia);
      timerZamkniecia = setTimeout(zamknij, OPOZNIENIE_ZAMKNIECIA);
    });

    summary.addEventListener('focus', () => {
      if (naMyszy()) otworz();
    });

    summary.addEventListener('click', (event) => {
      const url = summary.dataset.ppUrl;
      if (!naMyszy() || !url) return;
      event.preventDefault();
      window.location.href = url;
    });

    details.addEventListener('keyup', (event) => {
      if (event.code !== 'Escape') return;
      zamknij();
      summary.focus();
    });
  });
})();
